import React, { useMemo } from 'react';
import CustomSelect from '../../ui/CustomSelect';
import FormLabel from './FormLabel';
import { formatCurrencyInput, parseCurrency } from './utils/formatCurrency';
import { SLIK_STATUS_OPTIONS, SLIK_QUALITY_OPTIONS } from './utils/constants';

interface SLIKTabProps {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function SLIKTab({ formData, handleChange, errors = {} }: SLIKTabProps) {
  const formattedPlafon = useMemo(
    () => formatCurrencyInput(formData.slik_effective_plafon),
    [formData.slik_effective_plafon]
  );
  const formattedOutstanding = useMemo(
    () => formatCurrencyInput(formData.slik_outstanding),
    [formData.slik_outstanding]
  );

  const handlePlafonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = parseCurrency(e.target.value);
    handleChange('slik_effective_plafon', rawValue);
  };

  const handleOutstandingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = parseCurrency(e.target.value);
    handleChange('slik_outstanding', rawValue);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data SLIK</h3>
        <p className="text-gray-500 text-sm">Informasi hasil pengecekan SLIK OJK</p>
      </div>

      <div className="space-y-2">
        <FormLabel>Upload Dokumen SLIK</FormLabel>
        <input
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={e => {
            const file = e.target.files?.[0];
            if (file) {
              // File upload akan dihandle di parent component
              handleChange('slik_document_url', file.name);
            }
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
        />
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <FormLabel>Plafon Efektif (Rp)</FormLabel>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
              Rp
            </span>
            <input
              type="text"
              value={formattedPlafon}
              onChange={handlePlafonChange}
              className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="0"
            />
          </div>
        </div>
        <div>
          <FormLabel>Baki Debet (Rp)</FormLabel>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
              Rp
            </span>
            <input
              type="text"
              value={formattedOutstanding}
              onChange={handleOutstandingChange}
              className="w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="0"
            />
          </div>
        </div>
        <div>
          <FormLabel>Kualitas Terburuk</FormLabel>
          <CustomSelect
            value={formData.slik_worst_quality}
            onChange={v => handleChange('slik_worst_quality', v)}
            placeholder="Pilih"
            width="w-full"
            options={SLIK_QUALITY_OPTIONS}
          />
        </div>
        <div>
          <FormLabel>Bulan Data</FormLabel>
          <input
            type="text"
            value={formData.slik_data_month}
            onChange={e => handleChange('slik_data_month', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="Contoh: Januari 2024"
          />
        </div>
        <div>
          <FormLabel>Tanggal Posisi SLIK</FormLabel>
          <input
            type="date"
            value={formData.slik_position_date}
            onChange={e => handleChange('slik_position_date', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
          />
        </div>
        <div>
          <FormLabel>Skor SLIK</FormLabel>
          <input
            type="number"
            value={formData.slik_score}
            onChange={e => handleChange('slik_score', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="0-100"
          />
        </div>
        <div>
          <FormLabel>Status SLIK</FormLabel>
          <CustomSelect
            value={formData.slik_status}
            onChange={v => handleChange('slik_status', v)}
            placeholder="Pilih status"
            width="w-full"
            options={SLIK_STATUS_OPTIONS}
          />
        </div>
        <div>
          <FormLabel>Tanggal Cek SLIK Terakhir</FormLabel>
          <input
            type="date"
            value={formData.slik_last_check}
            onChange={e => handleChange('slik_last_check', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
          />
        </div>
      </div>

      <div>
        <FormLabel>Catatan</FormLabel>
        <textarea
          value={formData.notes}
          onChange={e => handleChange('notes', e.target.value)}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
          placeholder="Catatan tambahan tentang debitur"
        />
      </div>
    </div>
  );
}
